module.exports = __webpack_public_path__ + "static/media/enscape.16e113bb.png";